// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"c4236de1d5bdae72","5763":"6aafb97975bb8dd3","6893":"f62fbe0553c69ead","6974":"765e3d03576b2ed4","7222":"ac903f599de1869d","7937":"1017caedeb58b13f"}[chunkId] + ".js";
};